import moment from 'moment'

const LETTER_CHARS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
const INTEGER_CHARS = '0123456789'
const SYMBOL_CHARS = '!@#$%^&*()/?<>{}[]'
export function randomString({
  minLength = 0,
  maxLength = 50,
  fixedLength = null,
  include_integers = false,
  include_symbols = false,
} = {}) {
  let alphabet =
    LETTER_CHARS + (include_integers ? INTEGER_CHARS : '') + (include_symbols ? SYMBOL_CHARS : '')
  let result = ''
  const length = fixedLength || Math.max(Math.ceil(Math.random() * maxLength), minLength)
  for (let i = 0; i < length; i++) {
    const charIndex = Math.floor(Math.random() * alphabet.length)
    result += alphabet[charIndex]
  }
  return result
}

export function randomNumber({ maximum = 1000, integer = false, decimalPlaces = 2 } = {}) {
  let result = Math.random() * maximum
  return integer ? Math.floor(result) : result.toFixed(decimalPlaces)
}

export function checkNotNullOrUndefinedOrEmtpy(val) {
  return val == null || val == 'undefined' || (!Array.isArray(val) && !val.toString().length)
}

export function nFormatter(num, { digits = 2, includeZerosAfterPeriod = true, asUnit } = {}) {
  num = num * 1e6

  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'B' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ]
  let rx = /\.0+$|(\.[0-9]*[1-9])0+$/

  var item = asUnit
    ? lookup.find(i => i.symbol === asUnit)
    : lookup
        .slice()
        .reverse()
        .find(function(item) {
          return num >= item.value
        })

  //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace
  if (includeZerosAfterPeriod) {
    return item ? '$' + (num / item.value).toFixed(digits) + item.symbol : ''
  }
  return item ? '$' + (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : ''
}
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

export function currencyFilter(value) {
  if (!value) return formatter.format(0)

  return formatter.format(value)
}

export function currencyFilterNoCents(value) {
  if (!value) return formatter.format(0).split('.')[0]
  return formatter.format(value).split('.')[0]
}

export function fullDateShort(value) {
  if (!value) return ''
  return new Date(value).toLocaleDateString('en-us', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  })
}
export function monthYearDate(value) {
  if (!value) return ''
  return new Date(value).toLocaleDateString('en-us', {
    year: 'numeric',
    month: 'long',
  })
}

export function momentDateTime(value) {
  if (!value) return ''
  return new Date(value).toLocaleDateString('en-us', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}
export function momentDateShort(value) {
  if (!value) return ''
  return new Date(value).toLocaleDateString('en-us', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  })
}

export function momentDateTimeShort(value) {
  if (!value) return ''
  return moment.unix(value).format('LL')
}
export function momentTimeShort(value) {
  return moment.unix(value).format('HH:MM a')
}

/*
 * Tests
 */
const tests = [
  { num: 0, digits: 1 },
  { num: 12, digits: 1 },
  { num: 1234, digits: 2 },
  { num: 100000000, digits: 1 },
  { num: 299792458, digits: 1 },
  { num: 759878, digits: 1 },
  { num: 759878, digits: 0 },
  { num: 123, digits: 1 },
  { num: 123.456, digits: 1 },
  { num: 123.456, digits: 2 },
  { num: 123.456, digits: 4 },
]
function testNF() {
  tests.forEach(function(test) {
    console.log(
      'nFormatter(' +
        test.num +
        ', ' +
        test.digits +
        ') = ' +
        nFormatter(test.num, { digits: test.digits }),
    )
  })
}
function testCheckIsNotNulOrUndefinedorEmpty() {
  let res = ['test', null, 'undefined', undefined, {}, []].map(x =>
    checkNotNullOrUndefinedOrEmtpy(x),
  )
  let expectedRes = [false, true, true, true, false, false]
  console.log('res', res)
  console.log('res', expectedRes)
}
export class QuickSort {
  _arrSwap(arr, i, j) {
    let temp = arr[i]
    arr[i] = arr[j]
    arr[j] = temp
  }
  _partitionFlatArr(arr, start, end) {
    let pivot = arr[end]

    let i = start - 1

    for (let j = start; j <= end - 1; j++) {
      if (arr[j] <= pivot) {
        i++
        this._arrSwap(arr, i, j)
      }
    }
    this._arrSwap(arr, i + 1, end)

    return i + 1
  }
  _partitionObjArr(arr, start, end, key) {
    let pivot = arr[end][key]

    let i = start - 1

    for (let j = start; j <= end - 1; j++) {
      if (arr[j][key] <= pivot) {
        i++
        this._arrSwap(arr, i, j)
      }
    }
    this._arrSwap(arr, i + 1, end)

    return i + 1
  }
  sortFlatArr(arr = [], start = 0, end = 0) {
    if (start < end) {
      let part = this._partitionFlatArr(arr, start, end)

      this.sortFlatArr(arr, start, part - 1)

      this.sortFlatArr(arr, part + 1, end)
    }
  }
  sortObjArrByValue(arr = [], start = 0, end = 0, key) {
    if (start < end) {
      let part = this._partitionObjArr(arr, start, end, key)

      this.sortObjArrByValue(arr, start, part - 1, key)

      this.sortObjArrByValue(arr, part + 1, end, key)
    }
  }
  constructor() {}
}

function testQuickSort() {
  let arr = [1, 4, 6, 3, 5, 2]
  let arr1 = [1, 4, 3, 6, 5, 2]
  let arr2 = [6, 5, 4, 3, 2, 1]
  let arrs = [arr, arr1, arr2]

  let objArr1 = [{ key: 1 }, { key: 0 }, { key: 2 }, { key: 3 }]

  let qs = new QuickSort()
  arrs.forEach(a => {
    qs.sortFlatArr(a, 0, a.length - 1)
    console.log(a)
  })
  qs.sortObjArr(objArr1, 0, objArr1.length - 1, 'key')
  console.log(objArr1)
}
